import { render } from "./sidebar.vue?vue&type=template&id=89ead6ec&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=89ead6ec&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/RiverWQApp_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ead6ec"]])

export default __exports__